import React from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import images from "../../../../utilities/images/images";
import { url_291 } from "../../../../custom_utilities/api_services";
import DayStreak from "../DayStreak/DayStreak";
import { StreakMilestonePreview } from "../StreakMilestone/StreakMilestone";
import StreakCalendarModal from "./StreakCalendarModal";
import FreezePopupModal from "./FreezePopupModal";
import "./DailyGoalStreakPage.css";

function DailyGoalStreakPage({
  embedded = false,
  cardClassName = "",
  showViewMilestones = true,
}) {
  const history = useHistory();
  const [pageData, setPageData] = React.useState(null);
  const [isCalendarOpen, setIsCalendarOpen] = React.useState(false);
  const [isFreezeOpen, setIsFreezeOpen] = React.useState(false);

  React.useEffect(() => {
    const fetchEngageStreakCard = async () => {
      const response = await axios.get(url_291);
      if (response?.data?.status === 200) {
        setPageData(response.data.data);
      }
    };
    fetchEngageStreakCard();
  }, []);

  if (!pageData) return null;

  return (
    <main className={`daily-goal-streak${embedded ? " daily-goal-streak--embedded" : ""}`}>
      <div className={`daily-goal-streak__card ${cardClassName}`.trim()}>
        <header className="daily-goal-streak__hero">
          <div className="daily-goal-streak__hero-left">
            <img
              src={pageData?.action_icons?.fire_icon_url}
              alt=""
              className="daily-goal-streak__flame"
              width={44}
              height={44}
            />
            <div>
              <p className="daily-goal-streak__days">
                {pageData.streak_days} {pageData.streak_days === 1 ? "Day" : "Days"}
              </p>
              <p className="daily-goal-streak__subtitle">{pageData.streak_label}</p>
            </div>
          </div>

          <div className="daily-goal-streak__toolbar" role="group" aria-label="Streak utilities">
            <button
              type="button"
              className="daily-goal-streak__toolbar-btn"
              aria-label="Streak freeze"
              onClick={() => setIsFreezeOpen(true)}
            >
              <img
                src={pageData?.action_icons?.snowflake_url}
                alt=""
                className="daily-goal-streak__toolbar-img"
                width={20}
                height={20}
                aria-hidden="true"
              />
            </button>
            <button
              type="button"
              className="daily-goal-streak__toolbar-btn"
              aria-label="Calendar"
              onClick={() => setIsCalendarOpen(true)}
            >
              <img
                src={pageData?.action_icons?.calendar_url}
                alt=""
                className="daily-goal-streak__toolbar-img"
                width={20}
                height={20}
                aria-hidden="true"
              />
            </button>
          </div>
        </header>

        <section className="daily-goal-streak__week-section" aria-label="This week effort">
          <p className="daily-goal-streak__week-label">{pageData?.weekly_effort?.title}</p>
          <div className="daily-goal-streak__week-row" role="list">
            {pageData?.weekly_effort?.days?.map((d) => {
              const state = d.is_today ? "today" : d.streak_status === "achived" ? "done" : "upcoming";
              return (
                <div key={d.date} className="daily-goal-streak__day-cell" role="listitem">
                  <span className={`daily-goal-streak__dot daily-goal-streak__dot--${state}`} aria-hidden="true">
                    {state === "done" ? (
                      <span className="daily-goal-streak__check" aria-hidden="true">
                        <img src={images.engage_tick_icon} alt="" width={18} height={18} />
                      </span>
                    ) : null}
                  </span>
                  <span className={`daily-goal-streak__day-label${state === "today" ? " daily-goal-streak__day-label--today" : ""}`}>
                    {d.weekday_short}
                  </span>
                </div>
              );
            })}
          </div>
        </section>

        <StreakMilestonePreview title="Streak Milestones" titleSuffix=" (Achieved)" milestones={pageData?.milestone_badges} />

        <div className="daily-goal-streak__day-streak-wrap">
          <DayStreak
            badgeUrl={pageData?.streak_url}
            title={pageData?.card_title}
            subtitle={pageData?.footer_message}
            statusLabel={pageData?.status_label}
            isProgress={pageData?.is_progress}
          />
        </div>
      </div>

      {showViewMilestones ? (
        <button
          type="button"
          className="daily-goal-streak__view-milestones"
          onClick={() => history.push("/milestone-page-preview")}
        >
          <span className="daily-goal-streak__view-milestones-text">View Milestones</span>
          <img
            src={images.angle_right_icon}
            alt=""
            className="daily-goal-streak__view-milestones-icon"
            width={18}
            height={18}
            aria-hidden="true"
          />
        </button>
      ) : null}

      <StreakCalendarModal isOpen={isCalendarOpen} onClose={() => setIsCalendarOpen(false)} />
      <FreezePopupModal
        isOpen={isFreezeOpen}
        onClose={() => setIsFreezeOpen(false)}
        data={pageData?.streak_freeze_popup}
      />
    </main>
  );
}

export default DailyGoalStreakPage;
